import { FunctionComponent } from 'react'

import DrawerPortal, {
  DrawerPortalProps,
} from '@components/Drawer/DrawerPortal'

export type FollowMyTeamDrawerProps = Pick<
  DrawerPortalProps,
  'children' | 'onClose' | 'open'
>

const FollowMyTeamDrawer: FunctionComponent<FollowMyTeamDrawerProps> = ({
  open,
  children,
  onClose,
}) => (
  <DrawerPortal direction="right" open={open} onClose={onClose}>
    {open && children}
  </DrawerPortal>
)

export default FollowMyTeamDrawer
